// extracted by mini-css-extract-plugin
export default {"loginButton":"DiscordLogin_loginButton__2bRj0"};